import { render, staticRenderFns } from "./hotelit.vue?vue&type=template&id=1247d7eb&scoped=true"
import script from "./hotelit.vue?vue&type=script&lang=js"
export * from "./hotelit.vue?vue&type=script&lang=js"
import style0 from "./hotelit.vue?vue&type=style&index=0&id=1247d7eb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1247d7eb",
  null
  
)

export default component.exports